import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	draggableItemIndicatorAccessibilityLabel: {
		id: 'portal-settings-request-groups.common.draggable-item-indicator-accessibility-label',
		defaultMessage:
			'Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.',
		description: 'Accessibility Label for the draggable item',
	},
});
